import React, { FC, useState } from 'react';
import { PageWrapper, useShowAlertPopup, ProductCategoryForm, ProductCategory, FileUploadFile } from '@dew21/ui';
import axios from 'axios';
import { useHistory } from 'react-router';

export const AddProductCategory: FC = (props) => {
  const [product, setProduct] = useState<ProductCategory | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();

  return <PageWrapper
    breadCrumb={[
      { title: 'Produkte', path: '/products' },
      { title: 'Hinzufügen', path: `/products/category/new` },
    ]}
    marginal={{
      items: [],
    }}>
    <ProductCategoryForm
      onCancel={() => {
        history.push('/products');
      }}
      category={product}
      setProductCategory={(payload: { attachment: FileUploadFile, category: ProductCategory }) => {
        const data = {
          category: payload.category,
          attachment: payload.attachment ? payload.attachment : null,
        };

        axios.post(`/api/product/category/create`, data).then((response) => {
          setProduct(response.data);
          showNotificationBanner({ renderContent: () => <>Die Kategorie wurde angelegt.</> });
          history.push('/products');
        }).catch((error) => {
          showNotificationBanner({
            error: true,
            renderContent: () => <>Die Kategorie konnte nicht angelegt werden.</>,
          });
          console.log(error);
        });
      }}/>
  </PageWrapper>;
};
